const initialState = {
  resultsProductsList: [],
  resultsProduct: {},
  loading: false,
  error: null,
  productCreateResponse: null,
  productUpdateResponse: null,
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "LIST_PRODUCT_RESPONSE_GET":
      newState.resultsProductsList = action.value;
      break;
    case "PRODUCT_RESPONSE_GET":
      newState.resultsProduct = action.value;
    case "CREATE_PRODUCTS":
      return { ...state, loading: true, error: null };
    case "PRODUCTS_RESPONSE_CREATE":
      return {
        ...state,
        loading: false,
        productCreateResponse: action.value,
        error: action.value.responseStatus === "error" ? action.value : null
      };
    case "UPDATE_PRODUCT":
      return { ...state, loading: true, error: null };
    case "PRODUCTS_RESPONSE_UPDATE":
      return {
        ...state,
        loading: false,
        productUpdateResponse: action.value,
        error: action.value.responseStatus === "error" ? action.value : null
      };
    case "RESET_PRODUCTS_RESPONSES":
      return {
        ...state,
        resultsProductsList: {},
        resultsProduct: {},
        productCreateResponse: null,
        productUpdateResponse: null
      }
    default:
      break;
  }
  return newState;
}

export default reducer;
